import { render, staticRenderFns } from "./MenuAuthForm.vue?vue&type=template&id=5477bc30&"
import script from "./MenuAuthForm.vue?vue&type=script&lang=js&"
export * from "./MenuAuthForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports